import React, { useContext } from 'react';
import Badge from '@mui/material/Badge';
import * as styled from './styles';
import NavLink from '../NavLink';
import HashNavLink from '../HashNavLink';
import { ProductContext } from '../../context/products-context';

const Nav = () => {
  const { cartItems } = useContext(ProductContext);
  const numberOfItems = Object.values(cartItems).reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0,
  );
  return (
    <styled.Nav data-testid="header-nav">
      <styled.List>
        <NavLink to="/" data-testid="nav-home">
          Home
        </NavLink>
        <HashNavLink to="/about" data-testid="nav-about">
          About
        </HashNavLink>
        <NavLink to="/products" data-testid="nav-products">
          Products
        </NavLink>
        <NavLink to="/cart" data-testid="nav-cart">
          <Badge
            badgeContent={numberOfItems}
            max={9}
            color="default"
            sx={{
              mr: 1.5,
              '& .MuiBadge-badge': {
                backgroundColor: 'grey.600',
                color: 'common.white',
              },
            }}
            invisible={numberOfItems === 0}
          >
            <span>Cart</span>
          </Badge>
        </NavLink>
      </styled.List>
    </styled.Nav>
  );
};

export default Nav;
